import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

const CONSENT_KEY = 'prm_cookie_consent'; // 'accepted' | 'rejected'

const MARKETING_PATHS = [
  '/',
  '/business',
  '/about-us',
  '/contact',
  '/request-demo',
  '/download',
  '/privacy',
  '/cookies',
];

// Read consent state — returns 'accepted', 'rejected', or null
export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#1B4F8A',
    color: '#ffffff',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
    zIndex: 9999,
    fontFamily: 'Inter, Arial, sans-serif',
    fontSize: '14px',
    lineHeight: '1.5',
    boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.15)',
  },
  text: {
    flex: '1 1 400px',
    margin: 0,
  },
  link: {
    color: '#D6E4F3',
    textDecoration: 'underline',
  },
  buttons: {
    display: 'flex',
    gap: '10px',
    flexShrink: 0,
  },
  accept: {
    backgroundColor: '#2E86C1',
    color: '#ffffff',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: 'Inter, Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 600,
  },
  reject: {
    backgroundColor: 'transparent',
    color: '#D6E4F3',
    border: '1px solid #D6E4F3',
    padding: '10px 24px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: 'Inter, Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 600,
  },
};

const CookieConsent = ({ onConsentChange }) => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent && MARKETING_PATHS.includes(pathname)) {
      setVisible(true);
    }
  }, [pathname]);

  const handleChoice = (choice) => {
    try {
      localStorage.setItem(CONSENT_KEY, choice);
    } catch {
      // localStorage unavailable — consent still applies for this session
    }
    setVisible(false);
    if (onConsentChange) onConsentChange(choice);
  };

  if (!visible) return null;

  return (
    <div style={styles.banner} role="dialog" aria-label="Cookie consent">
      <p style={styles.text}>
        We use cookies to understand how visitors use our website and to improve your experience.{' '}
        <Link to="/cookies" style={styles.link}>Learn more</Link>
      </p>
      <div style={styles.buttons}>
        <button style={styles.reject} onClick={() => handleChoice('rejected')}>
          Reject
        </button>
        <button style={styles.accept} onClick={() => handleChoice('accepted')}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
